import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BACKEND_API } from "../../constants/backendApi";

//Style
import "./ButtonComponent.css";

//Context
import { PopupContext } from "../../context/PopupContext";
import { LoadingContext } from "../../context/LoadingContext";

const ButtonComponent = ({ btnData, hasBlock, block }) => {
  const { setLoading } = useContext(LoadingContext);

  const { setShowPopup, setPopupData } = useContext(PopupContext);

  const token = localStorage.getItem("token");

  const history = useNavigate();

  const handleDeleteCreditDataFromLS = () => {
    localStorage.removeItem("latestStep");
    localStorage.removeItem("processType");
    localStorage.removeItem("isCreditInProcess");
    setShowPopup(false);
  };

  const handleFromWhatsapp = () => {
    history("/");

    setTimeout(() => {
      localStorage.clear();
      window.location.href = "https://www.crediseguro.co";
    }, 100);
  };

  const handleSubmitData = () => {
    setLoading(true);

    setShowPopup(false);

    const { endpoint, is_from_whatsapp, difference_in_days, formData } =
      btnData?.complementInfo;

    try {
      if (!formData.es_renovacion) {
        try {
          fetch(`${BACKEND_API}${endpoint}`, {
            method: "PUT",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message.includes("Ya hay candidatos creados con ese")) {
                const errorListFromLs = JSON.parse(
                  localStorage.getItem("error_list")
                );

                const addNewError = [...errorListFromLs, "010"];

                localStorage.setItem("error_list", JSON.stringify(addNewError));

                setPopupData({
                  hasTitle: true,
                  hasInfoArr: true,
                  title: "",
                  infoArr: [
                    "El correo electrónico o número de celular ingresado ya se encuentra registrado en nuestra base de datos asociado a otro cliente. Por favor verifica la información. Si tienes dudas adicionales contacta a tu ejecutivo de CrediSeguro.",
                  ],
                  type: "option",
                  showOptionBtn: true,
                  isFromWhatsapp: false,
                  btnData: [
                    {
                      page: "login",
                      type: "redirect",
                      action: "close-popup",
                      text: "Cerrar",
                      title: "cerrar",
                      redirect: "/admin/crear-credito/formulario-confirmar",
                    },
                  ],
                });
                setShowPopup(true);
              }

              if (data.data.Estado === "Exitoso") {
                if (is_from_whatsapp) {
                  try {
                    const whatsappSessionId = localStorage.getItem(
                      "whatsapp_session_id"
                    );
                    const body = {
                      user_session_keys: [
                        {
                          key: "proceso_finalizado",
                          value: "1",
                        },
                        {
                          key: "numero_identificacion_confirmacion",
                          value: formData.numero_doc,
                        },
                        {
                          key: "nombre_cliente_confirmacion",
                          value: `${formData.nombres} ${formData.apellidos}`,
                        },
                        {
                          key: "placa_confirmacion",
                          value: formData.placa,
                        },
                        {
                          key: "numero_poliza_confirmacion",
                          value: formData.no_poliza,
                        },
                        {
                          key: "vigencia_confirmacion",
                          value: formData.vig_inicial,
                        },
                        {
                          key: "valor_confirmacion",
                          value: formData.prima_total,
                        },
                        {
                          key: "plazo_confirmacion",
                          value: formData.no_cuotas,
                        },
                      ],
                    };
                    fetch(
                      `https://main.treble.ai/session/${whatsappSessionId}/update`,
                      {
                        method: "POST",
                        headers: {
                          "Content-type": "application/json",
                        },
                        body: JSON.stringify(body),
                      }
                    )
                      .then((res) => res.json())
                      .then(() => {
                        console.log("Cerrada la sesión");
                      });
                  } catch (err) {
                    console.error(err);
                  }
                }
                if (
                  formData.aseguradora === "0013h00000GiwbTAAR" ||
                  formData.aseguradora === "0013h00000GiwbWAAR" ||
                  formData.aseguradora === "0013h00000GiwbaAAB" ||
                  formData.aseguradora === "0013h00000GiwbbAAB" ||
                  formData.aseguradora === "0013h00000DgV5TAAV" ||
                  formData.aseguradora === "001UL00000HxMYzYAN"
                ) {
                  if (
                    formData.doc_tomador === "901038608" ||
                    formData.doc_tomador === "9010386080"
                  ) {
                    setPopupData({
                      hasTitle: true,
                      hasInfoArr: true,
                      title: "",
                      infoArr: [
                        "Revisar tomador en caratula, registra Crediseguro y para la aseguradora en relación, Crediseguro no debe salir como tomador, agradecemos la corrección y volver a radicar para dar continuidad.",
                      ],
                      type: "option",
                      showOptionBtn: true,
                      isFromWhatsapp: is_from_whatsapp,
                      btnData: [
                        {
                          page: "login",
                          type: "redirect",
                          action: is_from_whatsapp ? "whatsapp" : "close-popup",
                          text: "Cerrar",
                          title: "cerrar",
                          redirect: "/admin/crear-credito/formulario-confirmar",
                        },
                      ],
                    });
                    setShowPopup(true);
                    return;
                  } else {
                    localStorage.setItem("isCreditInProcess", false);
                    localStorage.removeItem("fromRenovationTable");
                    localStorage.removeItem("form_id");
                    localStorage.removeItem("latestStep");
                    localStorage.removeItem("broker_id");
                    localStorage.removeItem("data");
                    localStorage.removeItem("userData");
                    localStorage.removeItem("processType");
                    localStorage.removeItem("insurance_id");
                    localStorage.removeItem("modifiedFields");
                    localStorage.removeItem("user_document");
                    localStorage.removeItem("error_list");
                    setPopupData({
                      title: "Enviado Exitosamente",
                      isFromWhatsapp: is_from_whatsapp,
                      info: `${
                        difference_in_days >= 30 && difference_in_days <= 35
                          ? "¡Alerta! Póliza cuenta con mas de 30 días desde inicio de vigencia. Se debe legalizar de inmediato firma y pago para evitar la anulación del crédito."
                          : difference_in_days >= 36
                          ? "¡Alerta! Póliza cuenta con mas de 35 días desde vigencia inicial. Crédito entra con riesgo de anulación."
                          : "Tu información ha sido recibida exitosamente."
                      }`,
                      type: "correct",
                    });
                    setShowPopup(true);
                    return;
                  }
                } else {
                  if (
                    formData.doc_tomador !== "901038608" &&
                    formData.doc_tomador !== "9010386080"
                  ) {
                    setPopupData({
                      hasTitle: true,
                      hasInfoArr: true,
                      title: "",
                      infoArr: [
                        "Revisar tomador en caratula, para la póliza en relación es necesario que Crediseguro registre como tomador, agradecemos la corrección y volver a radicar para dar continuidad.",
                      ],
                      type: "option",
                      showOptionBtn: true,
                      isFromWhatsapp: is_from_whatsapp,
                      btnData: [
                        {
                          page: "login",
                          type: "redirect",
                          action: is_from_whatsapp ? "whatsapp" : "close-popup",
                          text: "Cerrar",
                          title: "cerrar",
                          redirect: "/admin/crear-credito/formulario-confirmar",
                        },
                      ],
                    });
                    setShowPopup(true);
                    return;
                  } else {
                    localStorage.setItem("isCreditInProcess", false);
                    localStorage.removeItem("fromRenovationTable");
                    localStorage.removeItem("form_id");
                    localStorage.removeItem("latestStep");
                    localStorage.removeItem("broker_id");
                    localStorage.removeItem("data");
                    localStorage.removeItem("userData");
                    localStorage.removeItem("processType");
                    localStorage.removeItem("insurance_id");
                    localStorage.removeItem("modifiedFields");
                    localStorage.removeItem("user_document");
                    localStorage.removeItem("error_list");
                    setPopupData({
                      title: "Enviado Exitosamente",
                      isFromWhatsapp: is_from_whatsapp,
                      info: `${
                        difference_in_days >= 30 && difference_in_days <= 35
                          ? "¡Alerta! Póliza cuenta con mas de 30 días desde inicio de vigencia. Se debe legalizar de inmediato firma y pago para evitar la anulación del crédito."
                          : difference_in_days >= 36
                          ? "¡Alerta! Póliza cuenta con mas de 35 días desde vigencia inicial. Crédito entra con riesgo de anulación."
                          : "Tu información ha sido recibida exitosamente."
                      }`,
                      type: "correct",
                    });
                    setShowPopup(true);
                    return;
                  }
                }
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              setLoading(false);
            });
        } catch (err) {
          console.log(err);
        }
      }

      if (formData?.es_renovacion) {
        try {
          fetch(`${BACKEND_API}${endpoint}`, {
            method: "PUT",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message.includes("Ya hay candidatos creados con ese")) {
                const errorListFromLs = JSON.parse(
                  localStorage.getItem("error_list")
                );

                const addNewError = [...errorListFromLs, "010"];

                localStorage.setItem("error_list", JSON.stringify(addNewError));

                setPopupData({
                  hasTitle: true,
                  hasInfoArr: true,
                  title: "",
                  infoArr: [
                    "El correo electrónico o número de celular ingresado ya se encuentra registrado en nuestra base de datos asociado a otro cliente. Por favor verifica la información. Si tienes dudas adicionales contacta a tu ejecutivo de CrediSeguro.",
                  ],
                  type: "option",
                  showOptionBtn: true,
                  isFromWhatsapp: false,
                  btnData: [
                    {
                      page: "login",
                      type: "redirect",
                      action: "close-popup",
                      text: "Cerrar",
                      title: "cerrar",
                      redirect: "/admin/crear-credito/formulario-confirmar",
                    },
                  ],
                });
                setShowPopup(true);
              }

              if (data?.message === "informacion actualizada") {
                if (is_from_whatsapp) {
                  try {
                    const whatsappSessionId = localStorage.getItem(
                      "whatsapp_session_id"
                    );
                    const body = {
                      user_session_keys: [
                        {
                          key: "proceso_finalizado",
                          value: "1",
                        },
                        {
                          key: "numero_identificacion_confirmacion",
                          value: formData.num_document,
                        },
                        {
                          key: "numero_identificacion_confirmacion",
                          value: formData.numero_doc,
                        },
                        {
                          key: "nombre_cliente_confirmacion",
                          value: `${formData.nombres} ${formData.apellidos}`,
                        },
                        {
                          key: "placa_confirmacion",
                          value: formData.placa,
                        },
                        {
                          key: "numero_poliza_confirmacion",
                          value: formData.no_poliza,
                        },
                        {
                          key: "vigencia_confirmacion",
                          value: formData.vig_inicial,
                        },
                        {
                          key: "valor_confirmacion",
                          value: formData.prima_total,
                        },
                        {
                          key: "plazo_confirmacion",
                          value: formData.no_cuotas,
                        },
                      ],
                    };
                    fetch(
                      `https://main.treble.ai/session/${whatsappSessionId}/update`,
                      {
                        method: "POST",
                        headers: {
                          "Content-type": "application/json",
                        },
                        body: JSON.stringify(body),
                      }
                    )
                      .then((res) => res.json())
                      .then(() => {
                        console.log("Cerrada la sesión");
                      });
                  } catch (err) {
                    console.error(err);
                  }
                }
                if (
                  formData.aseguradora === "0013h00000GiwbTAAR" ||
                  formData.aseguradora === "0013h00000GiwbWAAR" ||
                  formData.aseguradora === "0013h00000GiwbaAAB" ||
                  formData.aseguradora === "0013h00000GiwbbAAB" ||
                  formData.aseguradora === "0013h00000DgV5TAAV" ||
                  formData.aseguradora === "001UL00000HxMYzYAN"
                ) {
                  if (
                    formData.doc_taker === "901038608" ||
                    formData.doc_taker === "9010386080"
                  ) {
                    setPopupData({
                      hasTitle: true,
                      hasInfoArr: true,
                      title: "",
                      infoArr: [
                        "Revisar tomador en caratula, registra Crediseguro y para la aseguradora en relación, Crediseguro no debe salir como tomador, agradecemos la corrección y volver a radicar para dar continuidad.",
                      ],
                      type: "option",
                      showOptionBtn: true,
                      isFromWhatsapp: is_from_whatsapp,
                      btnData: [
                        {
                          page: "login",
                          type: "redirect",
                          action: is_from_whatsapp ? "whatsapp" : "close-popup",
                          text: "Cerrar",
                          title: "cerrar",
                          redirect: "/admin/crear-credito/formulario-confirmar",
                        },
                      ],
                    });
                    setShowPopup(true);
                    return;
                  } else {
                    localStorage.setItem("isCreditInProcess", false);
                    localStorage.removeItem("fromRenovationTable");
                    localStorage.removeItem("form_id");
                    localStorage.removeItem("latestStep");
                    localStorage.removeItem("broker_id");
                    localStorage.removeItem("data");
                    localStorage.removeItem("userData");
                    localStorage.removeItem("processType");
                    localStorage.removeItem("insurance_id");
                    localStorage.removeItem("modifiedFields");
                    localStorage.removeItem("user_document");
                    localStorage.removeItem("error_list");
                    setPopupData({
                      title: "Enviado Exitosamente",
                      isFromWhatsapp: is_from_whatsapp,
                      info: `${
                        difference_in_days >= 30 && difference_in_days <= 35
                          ? "¡Alerta! Póliza cuenta con mas de 30 días desde inicio de vigencia. Se debe legalizar de inmediato firma y pago para evitar la anulación del crédito."
                          : difference_in_days >= 36
                          ? "¡Alerta! Póliza cuenta con mas de 35 días desde vigencia inicial. Crédito entra con riesgo de anulación."
                          : "Tu información ha sido recibida exitosamente."
                      }`,
                      type: "correct",
                    });
                    setShowPopup(true);
                    return;
                  }
                } else {
                  if (
                    formData.doc_tomador !== "901038608" &&
                    formData.doc_tomador !== "9010386080"
                  ) {
                    setPopupData({
                      hasTitle: true,
                      hasInfoArr: true,
                      title: "",
                      infoArr: [
                        "Revisar tomador en caratula, para la póliza en relación es necesario que Crediseguro registre como tomador, agradecemos la corrección y volver a radicar para dar continuidad.",
                      ],
                      type: "option",
                      showOptionBtn: true,
                      isFromWhatsapp: is_from_whatsapp,
                      btnData: [
                        {
                          page: "login",
                          type: "redirect",
                          action: is_from_whatsapp ? "whatsapp" : "close-popup",
                          text: "Cerrar",
                          title: "cerrar",
                          redirect: "/admin/crear-credito/formulario-confirmar",
                        },
                      ],
                    });
                    setShowPopup(true);
                    return;
                  } else {
                    localStorage.setItem("isCreditInProcess", false);
                    localStorage.removeItem("fromRenovationTable");
                    localStorage.removeItem("form_id");
                    localStorage.removeItem("latestStep");
                    localStorage.removeItem("broker_id");
                    localStorage.removeItem("data");
                    localStorage.removeItem("userData");
                    localStorage.removeItem("processType");
                    localStorage.removeItem("insurance_id");
                    localStorage.removeItem("modifiedFields");
                    localStorage.removeItem("user_document");
                    localStorage.removeItem("error_list");
                    setPopupData({
                      title: "Enviado Exitosamente",
                      isFromWhatsapp: is_from_whatsapp,
                      info: `${
                        difference_in_days >= 30 && difference_in_days <= 35
                          ? "¡Alerta! Póliza cuenta con mas de 30 días desde inicio de vigencia. Se debe legalizar de inmediato firma y pago para evitar la anulación del crédito."
                          : difference_in_days >= 36
                          ? "¡Alerta! Póliza cuenta con mas de 35 días desde vigencia inicial. Crédito entra con riesgo de anulación."
                          : "Tu información ha sido recibida exitosamente."
                      }`,
                      type: "correct",
                    });
                    setShowPopup(true);
                    return;
                  }
                }
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              setLoading(false);
            });
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {btnData.action === "close-popup" && (
        <Link
          onClick={() => setShowPopup(false)}
          className={btnData.page}
          type={btnData.type}
          title={btnData.title}
        >
          {btnData.text}
        </Link>
      )}
      {btnData.action === "submit" && (
        <button
          className={btnData.page}
          type={btnData.type}
          title={btnData.title}
          disabled={hasBlock ? block : false}
        >
          {btnData.text}
        </button>
      )}
      {btnData.action === "redirect" && (
        <Link
          className={btnData.page}
          type={btnData.type}
          title={btnData.title}
          disabled={hasBlock ? block : false}
          to={btnData.redirect}
        >
          {btnData.text}
        </Link>
      )}
      {btnData.action === "delete-data-ls" && (
        <Link
          onClick={handleDeleteCreditDataFromLS}
          className={btnData.page}
          type={btnData.type}
          title={btnData.title}
        >
          {btnData.text}
        </Link>
      )}
      {btnData.action === "from-whatsapp" && (
        <Link
          onClick={() => handleFromWhatsapp()}
          className={btnData.page}
          type={btnData.type}
          title={btnData.title}
        >
          {btnData.text}
        </Link>
      )}
      {btnData.action === "submit-data" && (
        <button
          className={btnData.page}
          type={btnData.type}
          title={btnData.title}
          disabled={hasBlock ? block : false}
          onClick={handleSubmitData}
        >
          {btnData.text}
        </button>
      )}
    </>
  );
};

export default ButtonComponent;
